var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.86603C11.4282 3.33013 12.5718 3.33013 13.5 3.86603L18.2942 6.63397C19.2224 7.16987 19.7942 8.16025 19.7942 9.23205V14.7679C19.7942 15.8397 19.2224 16.8301 18.2942 17.366L13.5 20.134C12.5718 20.6699 11.4282 20.6699 10.5 20.134L5.70577 17.366C4.77757 16.8301 4.20577 15.8397 4.20577 14.7679V9.23205C4.20577 8.16025 4.77757 7.16987 5.70577 6.63397L10.5 3.86603Z",
    stroke: "#D1D5DB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.134 5.5C11.5189 4.83333 12.4811 4.83333 12.866 5.5L18.0622 14.5C18.4471 15.1667 17.966 16 17.1962 16H6.80385C6.03405 16 5.55292 15.1667 5.93782 14.5L11.134 5.5Z",
    stroke: "#D1D5DB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graphIcon.220e6cc0c05f0a3c6febcab9ab5d8c3e.svg";
export { ForwardRef as ReactComponent };